// Shades of gray
export const LayoutSizes = {
    sideBarWidthSmall: ' w-1/5 mx-auto ml-0 p-4 -mt-10 ',
    sideBarWidthLarge: ' w-2/5 ml-0 p-4 -mt-10 ',
    primaryContainer: ' flex pt-2 pl-1 w-full h-full   ',
    dashboardHeaderClass: '  flex flex-col items-center justify-between h-full  w-14 relative '
};

export const TextSizes = {
    body: ' md:text-xxs lg:text-xs scale-75 ',
    xSmall: ' text-xs ',
    small: ' md:text-xs lg:text-sm ',
    header2: ' md:text-lg lg:text-xl font-semibold ',
    form: ' md:text-md lg:text-lg ',
    button: ' md:text-md lg:text-lg  ',
    button2: ' md:text-sm lg:text-md  ',
};

export const ZLevels = {
    topMost: ' z-50 ',
    aboveAll: ' z-40 ',
    above: ' z-30 ',
    default: ' z-20 ',
    below: ' z-10 ',
}

export const IconSizes = {
    icon3: ' scale-100 ',
    icon3Hover: ' hover:scale-125 ',
    iconHover: ' hover:scale-125 ',
};

/**
 * Generates a string of Tailwind CSS classes for visibility and pointer events
 * based on the provided isOpen condition.
 *
 * @param {boolean} isCollapsed - Determines if the content should be visible and interactive.
 * @returns {string} - A string of Tailwind CSS classes.
 */
export function CollapsibleClass(isCollapsed: boolean): string {
    return isCollapsed ? " invisible opacity-0 pointer-events-none " : " visible pointer-events-auto ";
}

/**
 * Generates a string of Tailwind CSS classes for visibility and pointer events
 * based on the provided isOpen condition.
 *
 * @param {boolean} isCollapsed - Determines if the content should be visible and interactive.
 * @param {string} visibleClass
 * @param {string} collapsedClass
 * @returns {string} - A string of Tailwind CSS classes.
 */
export function CollapsibleClassSizing(isCollapsed: boolean, visibleClass: string, collapsedClass: string): string {

    return isCollapsed ?
        " select-none invisible opacity-0 pointer-events-none overflow-hidden " + collapsedClass :
        " select-auto visible pointer-events-auto " + visibleClass;
}

export default {LayoutSizes, TextSizes, IconSizes};
